module.exports = __webpack_public_path__ + "./static/img/searchIcon.ea18ed89eb25d267114e24bd346ba614.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/searchIcon.png
// module id = ./client/src/assets/fontawesome/searchIcon.png
// module chunks = 0